import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const backend_domain = process.env.REACT_APP_BACKEND_DOMAIN;
const backend_port = process.env.REACT_APP_BACKEND_PORT;

export function useEnvolvementAccess(envolvementId: string) {
  const [hasAccess, setHasAccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { getAccessTokenSilently, user, isLoading: authLoading } = useAuth0();

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const accessToken = await getAccessTokenSilently();

        const response = await fetch(
          `${backend_domain}${backend_port}/payment/check-access/${envolvementId}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "user-id": user?.sub || "",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to check access");
        }

        const data = await response.json();
        setHasAccess(data.hasAccess);
      } catch (err) {
        console.error("Error checking access:", err);
        setError("Failed to verify access");
      } finally {
        setLoading(false);
      }
    };

    if (envolvementId && user?.sub) {
      checkAccess();
    } else if (!authLoading) {
      // Auth0 finished loading but user is not authenticated — no access
      setLoading(false);
    }
  }, [envolvementId, user?.sub, getAccessTokenSilently, authLoading]);

  return { hasAccess, loading, error };
}
